<template>
	<div class="modal fade innerpageModal show" tabindex="-1" style="display:block">
        <div class="modal-dialog" role="document">
            <div class="modal-content withdrawalAllow">
                <loader v-show="pageLoader" class="w-100"></loader>
                <div class="modal-header border-0">
                    <h5 class="modal-title" id="exampleModalLabel">Withdraw </h5>
                    <button type="button" class="close" @click="$parent.closeWithdrawal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
				<div class="scrollbar Mob" v-if="parseInt(get_user.tier) == 1">
					<div class="middleBlock">
						<div class="modal-body-area">
							<div class="modal-body">
								<div class="text-center">
									<div class="successImg mb-3 kycIco">
										<img src="../../../../static/website/images/kyc-group.svg" alt="Icon" width="320">
									</div>
									<p class="mb-0 text-center"><strong>KYC is Pending.</strong><span class="d-block kty">  Please 
										<router-link :to="'/individual-step'+(parseInt(get_user.step)+1)" v-if="parseInt(get_user.lead_type) == 0 && parseInt(get_user.step) < 3"><span class="bgIcon"></span> <strong>Click here</strong></router-link>
										<router-link :to="'/corporate-step'+(parseInt(get_user.step)+1)" v-if="parseInt(get_user.lead_type) == 1 && parseInt(get_user.step) < 4"><span class="bgIcon"></span> <strong>Click here</strong></router-link> to complete account verification for higher funding limits.</span>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="scrollbar Mob" v-else-if="parseInt(get_user.tier) == 2">
					<div class="middleBlock">
						<div class="modal-body-area">
							<div class="modal-body">
								<div class="text-center">
									<div class="successImg mb-3 kycIco">
										<img src="../../../../static/website/images/accountFrify.svg" alt="Icon" width="220">
									</div>
									<p class="mb-0 text-center">
										<strong> Your Account is under verification.</strong>
										<span class="d-block kty"> Please 
											<router-link :to="'/home'" ><span class="bgIcon"></span> <strong>Click here</strong></router-link> to view the verification status. </span>
									</p>
										
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="scrollbar Mob" v-else-if="parseInt(get_user.tier) == 3 && notCryptoCurrency.includes(withdrawalItem.symbol.toUpperCase())">
					<div class="middleBlock">
						<div class="modal-body-area">
							<div class="modal-body">
								<div class="text-center">
									<div class="successImg mb-3 kycIco">
										<img src="../../../../static/website/images/4389.svg" alt="Icon" width="320">
									</div>
									<p class="mb-0 text-center"><strong> We don’t have your Bank details.</strong><span class="d-block kty"> Please upload your bank documents for verification. </span></p>
								</div>
							</div>
						</div>
						<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4">
							<router-link class="cap_btn large_btn blue"  :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}">  Add Bank</router-link>
						</div>
					</div>
				</div>
				<div class="scrollbar Mob" v-else-if="parseInt(get_user.tier) == 4 && notCryptoCurrency.includes(withdrawalItem.symbol.toUpperCase())">
					<div class="middleBlock">
						<div class="modal-body-area">
							<div class="modal-body">
								<div class="text-center">
									<div class="successImg mb-3">
										<img src="../../../../static/website/images/accountFrify.svg" alt="Icon" width="220">
									</div>
									<p class="mb-0 text-center">
										<strong> Your Bank detail is under verification. </strong><span class="d-block kty">Please wait till approval from our Admin side. </span></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="mainBeforeKyc" v-else>
					<!-- After getting Transection id -->
					<!--  <div v-if="transaction_id != '' && success">
						<div class="middleBlock">
							<div class="modal-body-area">
								<div class="modal-body">
									<div class="text-center">
										<div class="successImg mb-3">
											<img src="../../../../static/website/images/successWithdrawal.svg" alt="Icon" width="120">
										</div>
										<p class="mb-0">You have successfully withdrawal</p>
									</div>
								</div>
							</div>
							<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4">
								<button type="button" class="cap_btn-b blue" @click="$parent.closeWithdrawal()">Close</button>
							</div>
						</div>
					</div> -->
					<div class="scrollbar Mob" v-if="transaction_id == '' && success">
						<div class="middleBlock">
							<div class="modal-body-area">
								<div class="modal-body">
									<alert-notification v-if="notification_msg != ''"/>
									<div class="text-center">
										<div class="successImg mb-3">
											<img src="../../../../static/website/images/successWithdrawal.svg" alt="Icon" width="120">
										</div>
										<p class="mb-0">You have successfully withdrawal</p>
									</div>
								</div>
							</div>
							<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4">
								<button type="button" class="cap_btn-b blue" @click="$parent.closeWithdrawal()">Close</button>
							</div>
						</div>
					</div>
					<div class="scrollbar Mob" v-if="transaction_id != '' && !success">
						<div class="modal-body-area" >
							<div class="modal-body customModalSecurity" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0">
								<app-twofa :call_from="'wallets'" v-if="two_fa" class="withdrawalAllow"></app-twofa>
								<div class="text-center"v-else>
									<alert-notification v-if="notification_msg != ''"/>
									<div class="successImg mb-3">
										<img src="../../../../static/website/images/smartphoneOtp.svg" alt="Icon" width="80">
									</div>
									<div class="authenticationApp">
										 <p class="mb-0"> Two factor authentication is disabled on your account. And as a security measure, we cannot process withdrawals unless 2FA is enabled. <a class="d-inline-block" @click="two_fa = true" href="#">Click here to Enable 2fa</a></p>
									</div>
									<!-- <p class="mb-0">  Two factor authentication is disabled on your account. And as a security measure, we cannot process withdrawals unless 2FA is enabled. <span class="cursor" @click="two_fa = true">Click here to Enable 2fa</span></p> -->
									
									<!-- <p>OTP sent for confirmation of withdrawal.</p>
									<p class="mb-3">Dear user, please click on the link sent to your email <strong>{{get_user.email}}</strong> to proceed with your withdrawal request.</p>
									<p>Email hasn’t arrived in your inbox, Click on <a href="#">Resend.</a>.</p> -->
									
									<!-- <div class="alrtMessage position-relative pl-5 pr-3 py-3 alert alert-warning mt-4 text-left">
										 <p class="mb-0"><feather class="alertIcon tp" size="20px" type="alert-octagon"></feather> Two factor authentication is disabled on your account. And as a security measure, we cannot process withdrawals unless 2FA is enabled. <span @click="$parent.withdrawalOtp = true">Click here to Enable 2fa</span></p>
									</div> -->
									<!-- <p>Two Factor Authentication is disabled on your Account</p>
									<p>*Two factor authentication provides an extra layer of protection to your account. It is a way of double checking that you are really the person who owns the account, when trying to log in. Click here to Enable 2FA on your Account.</p> -->
								</div>
							</div>
							<div class="OTPValidation text-center p-3" v-else>
								<div class="otpImg mb-4">
									<img src="../../../../static/website/images/smartphoneOtp.svg" alt="Icon" width="100">
								</div>
								<p>Please Enter 2FA</p>
								<div class="form-group">

									<input type="text" class="form-control" autocomplete="off" name="otp" required="" placeholder=" " v-model="otp" maxlength="6" v-validate="'required|numeric|max:6'"/>
									<label class="labeltext">Enter Google Authenticator Otp</label>
									<span v-if="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
								</div>
							</div>
						</div>
						<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4" >
							<button type="button" class="cap_btn-b blue" @click="$parent.closeWithdrawal()">Cancel</button>
							<button type="button" class="cap_btn blue" :class="(pageLoader)?'disabled':''"  @click="withdrawal_req_otp_check()" v-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 1">Submit</button>
							<!-- <button type="button" class="cap_btn blue" @click="$parent.withdrawalOtp = true" v-else>Enable 2fa</button> -->
						</div>
					</div>
					<!-- for none crypto currency -->
					<div class="scrollbar Mob" v-if="!isCrypto && transaction_id == ''  && !success">
						<div class="modal-body" >
							<alert-notification v-if="notification_msg != ''"/>
							<div class="interScroll mid_scroll_content customHeight section_title mb-0 text-center" v-if="!allowfiat">
								withdrawal doesn't allow  , because your country is not coming in fiat allowed countries
							</div>
							<div class="interScroll mid_scroll_content customHeight section_title mb-0 text-center" v-else>
								<!-- <p>{{withdrawalMethodResponseDep}}</p> --><!-- {{withdrawal_Bank}} -->
								<div v-if="bank_step == '1'">
									<div v-for="(list,key) in withdrawalMethodResponseDep" ><!--  v-if="parseInt(key) != 5" -->
										<!-- {{withdrawalMethodResponseDep[key]}} -->
										<div class="customWihdrawal" v-for="(bankList,index) in withdrawalMethodResponseDep[key]" @click="withdrawal_Bank = bankList.id+'-'+bankList.method">
											<div class="mb-3 position-relative" v-if="parseInt(bankList.method) == 1">
												<div class="list-group-item head d-flex justify-content-between align-items-center">
													<div>
														<p class="mr-3">
															<strong>Bank Name</strong>
															<span v-html="(bankList.bank_name != '' && bankList.bank_name != null)? bankList.bank_name : '-'"></span>
														</p>
														<p>
															<strong>Account Number</strong>
															<span v-html="(bankList.account_no != '' && bankList.account_no != null)? bankList.account_no : '-'"></span>
														</p>
													</div>  
													<!-- <div class="hitMob edt">
														<a href="#" class="themeColor animate-bottom mr-3" @click="detailDiv(index);">View detail</a>
														<a href="#" class="themeColor" v-if="parseInt(bankList.status) == 2">Pending</a>
														<a href="#" class="red" @click="disable(bankList );" v-else>Disable</a>
													</div> -->
												</div>
												<div class="bottomInfo fade" :ref="'buttons'+index">
													<div class="list-group-item">
														<span> Deposit Method</span>
														<span><img class="ml-2" :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
													</div>  
													<div class="list-group-item">
														<span>Account Name</span>
														<span v-html="(bankList.holder_name != '' && bankList.holder_name != null)? bankList.holder_name : '-'"></span>
													</div>
													<div class="list-group-item">
														<span>Swift/BIC/Sort Code</span>
														<span v-html="(bankList.sort_code != '' && bankList.sort_code != null)? bankList.sort_code : '-'"></span>
													</div>
													<div class="list-group-item">
														<span>IBAN</span>
														<span v-html="(bankList.micr != '' && bankList.micr != null)? bankList.micr : '-'"></span>
													</div>
													<div class="list-group-item">
														<span>Bank Address: </span>
														<span v-html="(bankList.bank_address != '' && bankList.bank_address != null)? bankList.bank_address : '-'"></span>
													</div>                               
												</div>  
											</div> 
											<div class="mb-3 position-relative" v-else-if="parseInt(bankList.method) == 2">
												<div class="list-group-item head align-items-center p-0"> 
													<div class="d-flex justify-content-start align-items-center">
														<p class="mr-3 mb-0 border-right p-3 text-center">
															<span><img   :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
															<br>
															<small> Deposit Method</small>
														</p> 
														<p>
															<strong>Online Payment ID:</strong>
															<span>{{bankList.online_payment_id}}</span>
														</p>
														
													</div>
													<!-- <div class="p-3 hitMob">
														<router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'2'}}">Change</router-link>
													</div> -->
												</div> 
											</div>
											<div class="mb-3 position-relative" v-else-if="parseInt(bankList.method) == 3">
												<div class="list-group-item head align-items-center p-0"> 
													<div class="d-flex align-items-center justify-content-start">
														<p class="mr-3 border-right p-3 text-center">
															<span><img   :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span>
															<br>
															<small>Deposit Method</small>

														</p>
														<p class="mr-3">
															<strong>Online Payment ID:</strong>
															<span>{{bankList.online_payment_id}}</span>
														</p> 
													</div> 
													<!-- <div class="p-3 hitMob">
														<router-link :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'3'}}">Change</router-link>
													</div> -->
												</div> 
											</div>	
											<div class="mb-3 position-relative" v-else-if="parseInt(bankList.method) == 5">
												<div class="list-group-item head align-items-center p-0"> 
													<div class="d-flex align-items-center justify-content-start">
														<div class="mr-3 border-right p-3 text-center">
															<span><img :src="'../../../../static/website/images/'+$env_var.withdrawalMethod[bankList.method]" width="50" alt="Bank Account"></span> <br>
															<small> Deposit Method</small>
														</div>
														<div>
															<p>
																<strong>Credit Card Number:</strong>
																<span> **** **** **** {{bankList.last_digit_card}}</span> <br>
															</p>
															<p>
																<strong>Expiry Date:</strong>
																<span> {{bankList.card_month}}/{{bankList.card_year}}</span> <br>
															</p>
														</div>
													</div> 
													<!-- <div class="p-3 hitMob">
														<a href="#" class="themeColor" v-if="parseInt(bankList.status) == 2">Pending</a>
														<a href="#" class="red" @click="disable(bankList );" v-else>Disable</a>
													</div> -->
												</div> 
											</div>
											<label class="customRadioButton">
												<input type="radio" :id="key+'_'+index" :value="bankList.id+'-'+bankList.method" name="method" v-model="withdrawal_Bank" v-validate="'required'">
												<span class="checkmark"></span>
											</label>
										</div>
									</div>	
									<span v-if="submitted && errors.has('method')" class="text-danger">{{ errors.first('method') }}</span>
									<div class="noDetails-empty mb-4" v-if="Object.keys(withdrawalMethodResponseDep).length == 0">
										<div class="list-group-items border-0 text-center">
											<span class="imageBelow">
												<img src="../../../../static/website/images/undraw_pay_online.svg" alt="Icon">
											</span>
											<h4>No Bank Detail Yet</h4>
											<span></span>
										</div> 
										<div class="addBank text-center mt-3">
											<router-link class="cap_btn-b" :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'1'}}"> <feather type="folder-plus"></feather> Add Bank</router-link>
											<!-- <router-link class="cap_btn-b" :to="{name: 'support' , params: { 'tabName':'requestServiceElement','page':'profile', 'ticketData' : '16','method_id':'5'}}"> <feather type="folder-plus"></feather> Add Credit card</router-link> -->
										</div>
									</div>
								</div>
								<div class="midContent section_title mb-0 text-center" v-else-if="bank_step == '2'">
									<div class="form-group withdrawlAmmount mb-2">
										<div class="totalAmmoouut d-flex justify-content-between mb-3">
											<label> Total Amount</label>
											<p class="d-flex align-items-center">
											<span class="inTableIcon" v-if="withdrawalItem.symbol">
												<img class="amountIcon" :src="'../../../../static/website/images/crypto_logos/'+withdrawalItem.symbol.toLowerCase()+'.png'" @error="handleImgErr($event)" v-if="!imageError">
												<span class="firstName" v-else>{{withdrawalItem.symbol.charAt(0)}}</span>
											</span> {{withdrawalItem.amount}}</p>
										</div>
										<div class="fixedAmount position-relative">
											<input type="text" class="form-control" autocomplete="off" name="amount" required="" placeholder=" " v-model="withdraw_amount" v-validate="{required:true ,decimal:8, max_value: withdrawalItem.amount,regex: /^(?=.*[1-9])\d+(\.\d+)?$/}"/>
											<label class="labeltext">Withdraw Amount</label>
											<div class="nameCruncy">
												<span>{{withdrawalItem.symbol}}</span>
											</div>
										</div>
										<span v-if="submitted && errors.has('amount')" class="text-danger">{{ ( errors.first('amount').includes('format is invalid') )?'Amount should be greater than 0':errors.first('amount') }}</span>
									</div>
									<div class="priceTable border-0 text-left mt-2">
										<table class="table sellTable border-0 m-0">
											<tbody>
												<tr>
													<th>Transaction Fee</th>
													<td v-if="withdrawalItem.keyType == 'ERC20' && withdrawalItem.symbol != 'ETH'">{{(withdraw_amount)?numberFormat( 21000  * withdraw_amount * 0.00000002 ) : '-'}} ETH</td>
													<td v-else>{{(withdraw_amount)?numberFormat((withdraw_amount/100) * 0.5):'-'}} {{withdrawalItem.symbol}}</td>
												</tr>
												<tr>
													<th>Total Withdrawal</th>
													<td>{{(withdraw_amount)?(withdraw_amount - ((withdraw_amount/100) * 0.5) ):'-'}} {{withdrawalItem.symbol}}</td>
												</tr>
											</tbody>
										</table>
									</div>

								</div>
								<!-- <div class="subtitle msgCenter" v-else>
									<div class="duccessImg">
										<img src="../../../../static/website/images/mailSent.svg" alt="Icon" width="80">
									</div>
									<p class="mb-3">Dear <strong class="green">{{get_user.profile.firstname}}</strong> We've send an link on your email <strong>{{get_user.email}} . </strong> Kindly click on that link to proceed with your request</p>
									<a v-on:click="resendLink()" href="#" class="mb-3"><strong>Haven't received an email in your inbox or spam folder? Resend</strong></a>
								</div> -->
							</div>
						</div>
						<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4" >
							<button type="button" class="cap_btn-b blue" @click="$parent.closeWithdrawal()">Cancel</button>
							<div v-if="Object.keys(withdrawalMethodResponseDep).length > 0 && allowfiat">
								<button type="button" class="cap_btn blue" @click="changeStep('2')" v-if="bank_step == '1'">Submit</button>
								<button type="button" class="cap_btn blue" :class="(pageLoader)?'disabled':''"  @click="withdrawal_req_otp()" v-else-if="transaction_id == '' && 'amount' in withdrawalItem && withdrawalItem.amount > 0">Submit</button>
							</div>
						</div>
					</div>
					<!-- for crypto currency -->
					<div class="scrollbar Mob" v-if="isCrypto && transaction_id == '' && !success">
						<div class="modal-body">
							<div class="midContent section_title mb-0 text-center">
								<alert-notification v-if="notification_msg != ''"/>
								<div class="form-group">
									<input type="text" class="form-control" autocomplete="off" name="addess" required="" placeholder=" " v-model="crypto_addess" v-validate="'required'"/>
									<label class="labeltext">Verify wallet Address</label>
									<span v-if="submitted && errors.has('addess')" class="text-danger">{{ errors.first('addess') }}</span>
								</div>
								<div class="form-group withdrawlAmmount mb-2">
									<div class="totalAmmoouut d-flex justify-content-between mb-3">
										<label class="d-flex align-items-center"> Total Amount</label>
										<p class="d-flex align-items-center">
											<span class="inTableIcon" v-if="withdrawalItem.symbol">
												<img class="amountIcon" :src="'../../../../static/website/images/crypto_logos/'+withdrawalItem.symbol.toLowerCase()+'.png'" @error="handleImgErr($event)" v-if="!imageError">
												<span class="firstName" v-else>{{withdrawalItem.symbol.charAt(0)}}</span>
											</span> {{withdrawalItem.amount}}</p>
									</div>
									<div class="fixedAmount position-relative">
										<input type="text" class="form-control" autocomplete="off" name="amount" required="" placeholder=" " v-model="withdraw_amount" v-validate="{'required':true,'decimal':8,'max_value':withdrawalItem.amount,regex: /^(?=.*[1-9])\d+(\.\d+)?$/}"/>
										<label class="labeltext">Withdraw Amount</label>
										<div class="nameCruncy">
											<span>{{withdrawalItem.symbol}}</span>
										</div>
									</div>
									<span v-if="submitted && errors.has('amount')" class="text-danger">{{ ( errors.first('amount').includes('format is invalid') )?'Amount should be greater than 0':errors.first('amount') }}</span>
								</div>
								<div class="priceTable border-0 text-left mt-2">
									<table class="table sellTable border-0 m-0">
										<tbody>
											<tr>
												<th>Transaction Fee</th>
												<td v-if="withdrawalItem.keyType == 'ERC20' && withdrawalItem.symbol != 'ETH'">{{(withdraw_amount)?numberFormat( 21000  * withdraw_amount * 0.00000002 ) : '-'}} ETH</td>
												<td v-else>{{(withdraw_amount)?numberFormat((withdraw_amount/100) * 0.5):'-'}} {{withdrawalItem.symbol}}</td>
											</tr>
											<tr>
												<th>Total Withdrawal</th>
												<td>{{(withdraw_amount)?(withdraw_amount - ((withdraw_amount/100) * 0.5) ):''}} {{withdrawalItem.symbol}}</td>
											</tr>
										</tbody>
									</table>
								</div>
							   
								<div class="alrtMessage position-relative pl-5 pr-3 py-3 alert alert-warning mt-4 text-left">
									 <p class="mb-0"><feather class="alertIcon tp" size="20px" type="alert-octagon"></feather> Due to the irreversible nature of cryptocurrencies, transactions can neither be cancelled nor reversed once initiated. Therefore, please ensure that the wallet address you entered is correct and created for the coin you are withdrawing. If you enter a wrong wallet address, you risk losing your funds permanently.</p>
								</div>
								<!-- <div class="resultCru">
									<p>= 0.000000 BTC <span>($0.0000 USD)</span></p>
								</div> -->
							</div>
						</div>
						<div class="modal-footer d-flex justify-content-center border-0 pt-0 pb-4" >
							<button type="button" class="cap_btn-b blue" @click="$parent.closeWithdrawal()">Cancel</button>
							<button type="button" class="cap_btn blue"  :class="(pageLoader)?'disabled':''" @click="withdrawal_req_otp()" v-if="transaction_id == '' && 'amount' in withdrawalItem && withdrawalItem.amount > 0">Submit</button>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
    import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
    import tradingMixins from '@/plugins/trading';
    import TwoFa from '../security/security'
    export default {
        name: 'Deposit',
        mixins: [depositWithdrawalMixins,tradingMixins],
        data() {
            return {
				//platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				// showIndex : '-1'
				pageLoader : false,
				notification_msg:'',
            	notification_type:'',
				notCryptoCurrency:['EURO','USD','AUD','GBP','JPY'],
	            isCrypto : true,
	            allowfiat : true,
	            bank_step : '1',
				crypto_addess:'',
				withdraw_amount:'',
	            transaction_id: '',
	            withdrawal_Bank:'',
	            submitted: false,
	            otp:'',
	            two_fa : false,
	            success : false,
	            imageError : false,
	            msg: ''
            }
        },
        components:{
	        appTwofa : TwoFa
	    },
        props:['withdrawalItem'],
        methods:{
        	handleImgErr(val){
				this.imageError = true
			},
        	changeStep(step){
        		const _that = this
	            _that.submitted = true;
	            _that.$validator.validate().then(valid => {
	                if (valid) {
	                	_that.bank_step = step
	                }
	            })
        	},
        	withdrawal_req_otp_check(){
        		if(this.pageLoader){return;}
	            const _that = this
	            _that.submitted = true;
	            _that.$validator.validate().then(valid => {
	                if (valid) {
	                    this._runWithdrawalCheckOtp({'globalParams' :{
	                        'trans_id' : _that.transaction_id,
	                        "otp" : _that.otp ,
	                        "verify" : ""
	                    }, 'localParams' :{"parameter" : this}})
	                }
	            })
	        },
			withdrawal_req_otp(){
				if(this.pageLoader){return;}
				var account_id = '';
				this.tradingAccount[0].subAccounts.forEach(value =>{
					if(this.withdrawalItem.symbol == value.currency){
						account_id = value.act_account_id
					}
				})
				// console.log('withdrawalItem',this.withdrawalItem.symbol,this.tradingAccount[0].subAccounts)
	            const _that = this
	            _that.submitted = true;
	            _that.$validator.validate().then(valid => {
	                if (valid) {
	        			var inputJson = { 'globalParams' :{
	        				"account_id" : _that.tradingAccount[0].account_id,
	        				"act_account_id" : account_id,
	        				"amount" : _that.withdraw_amount,
	        				"address" : _that.crypto_addess,
	        				"crypto" : _that.withdrawalItem.symbol,
	        				"method_id" : "",
	        				"withdrawal_method" : ""
	        			}, 'localParams' :{"parameter" : _that} }
	        			if(!this.isCrypto){
	        				inputJson.globalParams.method_id = this.withdrawal_Bank.split('-')[0]
	        				inputJson.globalParams.withdrawal_method = this.withdrawal_Bank.split('-')[1]
	        			}
	        			console.log('inputJson---->',inputJson)
	        			this._runWithdrawalRequestOtp(inputJson)
	                }
	            })
			},
        },
        created(){
			if(this.notCryptoCurrency.includes(this.withdrawalItem.symbol.toUpperCase())){
				this.isCrypto = false
				// console.log(Object.values(this.$env_var.fiatAllowCountries))
				if(this.get_user.profile.country && Object.values(this.$env_var.fiatAllowCountries).includes(this.get_user.profile.country)){
					this.allowfiat = true
				}
			}
			this._runGetWithdrawalMethods({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/deposit-withdrawal/popup_withdraw.vue